import { styled } from "@mui/material";

export const PageWrapper = styled("div")({
  width: "100%",
});

export const HeroSection = styled("div")({
  position: "relative",
  minHeight: "100vh",
  width: "100%",
});

export const BackgroundComponent = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "linear-gradient(-180deg, #ffffff, #ffffff, #ffb6c1)",
  zIndex: 0,
});

export const PersonContainer = styled("div")({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "400px",
  height: "700px",
  zIndex: 1,
  overflow: "hidden",
});

export const ContentArea = styled("div")({
  position: "relative",
  zIndex: 2,
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "2rem",
});

export const HeaderContainer = styled("div")({
  width: "100%",
  marginBottom: "2rem",
  display: "flex",
  justifyContent: "start",
});

export const FormContainer = styled("div")({
  width: "100%",
  marginLeft: "30px",
});

export const AdditionalContent = styled("div")({
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "4rem 2rem",
});

export const ContentBlock = styled("div")<{ first?: boolean }>(({ first }) => ({
  width: "100%",
  height: "300px",
  border: "2px dashed #666",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#333",
  fontWeight: "bold",
  marginTop: first ? "0" : "2rem",
}));
